
















































































import { WayBill } from '@/http';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
@Component({
    components: {
        BaseInfoPanel
    },
})
export default class Evalute extends Vue {
    @Prop()
    public value: any;
    public evalute: any = {
        id: '',
        carrierOrderId: '',
        carrierOrderCode: '',
        driverPhone: '',
        goodsBroken: '',
        managementSite: '',
        managementSiteInt: '',
        carrierName: '',
        carCode: '',
        driverName: '',
        goodsBrokenInt: '',
        score: '',
        content: '',
        isEvaluate: false,
    };
    public muti: any = [];
    public fee: any = ''; //财务模块跳转字段
    public loading:boolean = false;
    mounted() {
        this.fee = this.$route.query.fee;
        this.muti = this.value.managementSite.split(',');
        this.evalute = { ...this.value };
        this.evalute.goodsBrokenInt = this.evalute.goodsBrokenInt ? this.evalute.goodsBrokenInt.toString() : '';
    }
    back() {
        if (this.fee) {
            switch (this.fee) {
                case '1':
                    this.$router.push('/CostAudit');
                    break;
                case '2':
                    this.$router.push('/CostDetail');
                    break;
                case '3':
                    // this.$router.go(-1);
                    this.$router.push({
                        path: '/statementDetails',
                        query: {
                            id: this.$route.query.feeId,
                        },
                    });
                    break;
                default:
                    break;
            }
        } else {
            this.$router.push('/WayBillManage');
        }
    }
    public checks = { 扰乱现场秩序: 1, 危险作业: 2, 不服从管理: 3 };
    pj() {
        let checks = this.muti.join();
        let goodsBroken = '';
        if (this.evalute.goodsBrokenInt) {
            goodsBroken = this.evalute.goodsBrokenInt === '1' ? '轻微货损' : '严重货损';
        }
        let managementSiteInt = [];
        for (let i = 0; i < this.muti.length; i++) {
            managementSiteInt.push(this.checks[this.muti[i]]);
        }
        WayBill.Evalute({
            id: this.evalute.id,
            goodsBroken: goodsBroken,
            goodsBrokenInt: this.evalute.goodsBrokenInt,
            managementSite: checks,
            managementSiteInt: managementSiteInt.join(),
            score: this.evalute.score,
            content: this.evalute.content,
        }).then((res) => {
            console.log('res=>', res);
            this.$message.success('评论成功!');
            this.$router.push('/WayBillManage');
        });
    }
    changeRadio(val) {
        val === this.evalute.goodsBrokenInt ? (this.evalute.goodsBrokenInt = '') : (this.evalute.goodsBrokenInt = val);
    }
}
